interface Props {
    word: string;
    simpleWord: string;
    definitions: string[];
}

export default class HebrewDefinition {

    public constructor(private readonly props: Props) {
    }

    public getWord(): string {
        return this.props.word;
    }

    public getSimpleWord(): string {
        return this.props.simpleWord;
    }

    public getDefinitions(): string[] {
        return this.props.definitions;
    }
}
